import { Menu, Select } from 'antd5';
import styled from 'styled-components';

import { Theme } from 'utils/color/horizonTheme';

export const StyledMenu = styled(Menu)`
  background-color: ${({ theme }) =>
    theme.themeName === Theme.Dark
      ? theme.tertiaryBackgroundColor
      : theme.secondaryBackgroundColor};
`;

export const StyledSelect = styled(Select)`
  width: auto;
  min-width: 200px;
`;
